var map = {
	"./gymnastics/gymnastics-silhouette-1.jpg": 19981,
	"./gymnastics/gymnastics-silhouette-2.jpg": 90722,
	"./gymnastics/gymnastics-silhouette-3.jpg": 3391,
	"./gymnastics/gymnastics-silhouette-4.jpg": 82580,
	"./gymnastics/gymnastics-silhouette-5.jpg": 79953,
	"./gymnastics/gymnastics-silhouette-6.jpg": 22182,
	"./gymnastics/gymnastics-silhouette-7.jpg": 60707,
	"./gymnastics/gymnastics-silhouette-8.jpg": 97208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95699;